import React from 'react';
import { ExportButton } from 'react-admin';
import CardActions from '@material-ui/core/CardActions';

type Props = {
  currentSort: any,
  displayedFilters?: any,
  exporter: boolean | any,
  filters: any,
  filterValues: any,
  resource: string,
  showFilter: any
};

const ListActions = ({ filters, resource, showFilter, displayedFilters, filterValues, currentSort, exporter }: Props) => (
  <CardActions>
    {filters && React.cloneElement(filters, { resource, showFilter, displayedFilters, filterValues, context: 'button' })}
    <ExportButton resource={resource} sort={currentSort} filter={filterValues} exporter={exporter} maxResults={2000} />
  </CardActions>
);

export default ListActions;



// WEBPACK FOOTER //
// ./src/views/Components/Reports/ChangeHistory/Helpers/ListActions.tsx